module.exports = __webpack_public_path__ + "media/images/nl/rejected-f4142d632fc5bce88cf552428a464227.png";